import React from 'react';
import { useFormContext } from 'react-hook-form';
import useImpactOptions from '@components/EntityDrawers/drawers/Risk/hooks/useImpactOptions';
import useRiskScore from '@components/EntityDrawers/drawers/Risk/hooks/useRiskScore';
import { RiskKeys } from '@components/EntityDrawers/drawers/Risk/keys';
import ControlledTextFieldSelect from '@components/Inputs/controllers/ControlledTextFieldSelect';
import { useProject } from '@context/Project/ProjectProvider';

const ResidualImpact = () => {
  const { viewOnly } = useProject();
  const { watch, setValue } = useFormContext();
  const { calculateRiskScore } = useRiskScore();
  const options = useImpactOptions();

  const handleScoreCalculate = (impact: string) => {
    const score = calculateRiskScore({
      likelihood: watch(RiskKeys.ResidualLikelihood),
      impact,
    });

    setValue(RiskKeys.ResidualScore, score, { shouldValidate: true });
  };

  return (
    <ControlledTextFieldSelect
      name={RiskKeys.ResidualImpact}
      label="Residual risk impact"
      placeholder="Choose residual risk impact"
      disabled={viewOnly || !watch(RiskKeys.HasCapability)}
      options={options}
      resetOnDoubleClick
      required
      changeHandler={handleScoreCalculate}
    />
  );
};

export default ResidualImpact;
